var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    multiple: "",
                    "collapse-tags": "",
                    clearable: "",
                    filterable: "",
                    placeholder: "应用"
                  },
                  model: {
                    value: _vm.paramsData.appid,
                    callback: function($$v) {
                      _vm.$set(_vm.paramsData, "appid", $$v)
                    },
                    expression: "paramsData.appid"
                  }
                },
                _vm._l(_vm.appListAllData, function(item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.name, value: item.appid }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    clearable: "",
                    filterable: "",
                    placeholder: "订单状态"
                  },
                  model: {
                    value: _vm.paramsData.order_state,
                    callback: function($$v) {
                      _vm.$set(_vm.paramsData, "order_state", $$v)
                    },
                    expression: "paramsData.order_state"
                  }
                },
                _vm._l(_vm.orderStatus, function(item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "研发订单ID" },
                model: {
                  value: _vm.paramsData.developer_order_id,
                  callback: function($$v) {
                    _vm.$set(_vm.paramsData, "developer_order_id", $$v)
                  },
                  expression: "paramsData.developer_order_id"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "研发用户ID" },
                model: {
                  value: _vm.paramsData.developer_user_id,
                  callback: function($$v) {
                    _vm.$set(_vm.paramsData, "developer_user_id", $$v)
                  },
                  expression: "paramsData.developer_user_id"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "支付订单ID" },
                model: {
                  value: _vm.paramsData.pay_order_id,
                  callback: function($$v) {
                    _vm.$set(_vm.paramsData, "pay_order_id", $$v)
                  },
                  expression: "paramsData.pay_order_id"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "支付渠道订单ID" },
                model: {
                  value: _vm.paramsData.third_part_order_id,
                  callback: function($$v) {
                    _vm.$set(_vm.paramsData, "third_part_order_id", $$v)
                  },
                  expression: "paramsData.third_part_order_id"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "登录用户ID" },
                model: {
                  value: _vm.paramsData.login_user_id,
                  callback: function($$v) {
                    _vm.$set(_vm.paramsData, "login_user_id", $$v)
                  },
                  expression: "paramsData.login_user_id"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "网关ID" },
                model: {
                  value: _vm.paramsData.gate_user_id,
                  callback: function($$v) {
                    _vm.$set(_vm.paramsData, "gate_user_id", $$v)
                  },
                  expression: "paramsData.gate_user_id"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c("el-date-picker", {
                attrs: {
                  "picker-options": _vm.pickerOptionsMonth,
                  clearable: "",
                  "value-format": "yyyy-MM",
                  type: "month",
                  placeholder: "请选择月份"
                },
                on: { change: _vm.seachDateAllChange },
                model: {
                  value: _vm.searchDateStr,
                  callback: function($$v) {
                    _vm.searchDateStr = $$v
                  },
                  expression: "searchDateStr"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    multiple: "",
                    "collapse-tags": "",
                    clearable: "",
                    filterable: "",
                    placeholder: "支付类型"
                  },
                  on: { change: _vm.payTypeChange },
                  model: {
                    value: _vm.payData,
                    callback: function($$v) {
                      _vm.payData = $$v
                    },
                    expression: "payData"
                  }
                },
                _vm._l(_vm.appPaymentTypeAllData, function(item) {
                  return _c("el-option", {
                    key: item.p_type,
                    attrs: { label: item.type_name, value: item.p_type }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "设备ID" },
                model: {
                  value: _vm.paramsData.device_id,
                  callback: function($$v) {
                    _vm.$set(_vm.paramsData, "device_id", $$v)
                  },
                  expression: "paramsData.device_id"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "operationBut", attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.reqLoading },
                  on: {
                    click: function($event) {
                      return _vm.getList()
                    }
                  }
                },
                [_vm._v("搜索")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", disabled: !_vm.tableData.length },
                  on: { click: _vm.exportDataFn }
                },
                [_vm._v("导出")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.reqLoading,
              expression: "reqLoading"
            }
          ],
          attrs: { data: _vm.tableData, border: "" }
        },
        [
          _c("el-table-column", {
            attrs: { prop: "gate_user_id", label: "网关用户ID", width: "300" }
          }),
          _c("el-table-column", {
            attrs: { prop: "login_user_id", label: "登录用户ID", width: "300" }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "developer_user_id",
              label: "研发用户ID",
              width: "160"
            }
          }),
          _c("el-table-column", {
            attrs: { prop: "gate_order_id", label: "网关订单号", width: "220" }
          }),
          _c("el-table-column", {
            attrs: { prop: "pay_order_id", label: "支付订单ID", width: "220" }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "developer_order_id",
              label: "研发订单ID",
              width: "360"
            }
          }),
          _c("el-table-column", {
            attrs: { prop: "device_id", label: "设备ID", width: "240" }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "third_part_pay_type_id",
              label: "支付平台类型ID",
              width: "160"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "third_part_pay_type",
              label: "支付平台类型",
              width: "160"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    row.pay_type_icon
                      ? [
                          _c("el-image", {
                            staticStyle: { width: "60px", height: "60px" },
                            attrs: { src: row.pay_type_icon, fit: "cover" }
                          })
                        ]
                      : [_vm._v(" " + _vm._s(row.third_part_pay_type) + " ")]
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "third_part_order_id",
              label: "支付渠道订单ID",
              width: "240"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _vm._v(" " + _vm._s(row.third_part_order_id || "/") + " ")
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "server_id", label: "服务器ID", width: "100" }
          }),
          _c("el-table-column", {
            attrs: { prop: "product", label: "游戏内商品", width: "160" }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "product_name",
              label: "商品名称",
              width: "160",
              "show-overflow-tooltip": ""
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "product_desc",
              label: "商品描述",
              width: "160",
              "show-overflow-tooltip": ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c(
                      "div",
                      {
                        staticClass: "text-ellipsis-1",
                        staticStyle: { width: "180px", "text-align": "left" }
                      },
                      [_vm._v(" " + _vm._s(row.product_desc || "/") + " ")]
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "price", label: "商品价格(元)", width: "140" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _vm._v(" " + _vm._s(_vm.$utils.conversion(row.price)) + " ")
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "third_part_product",
              label: "支付平台商品",
              width: "160"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "third_part_price",
              label: "游戏内商品价格(元)",
              width: "160"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$utils.conversion(row.third_part_price)) +
                        " "
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "order_state", label: "订单状态", width: "140" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.orderStatus.find(function(i) {
                            return i.value == row.order_state
                          }).label
                        ) +
                        " "
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "deliver_state", label: "网关状态", width: "140" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.deliverStatus.find(function(i) {
                            return i.value == row.deliver_state
                          }).label
                        ) +
                        " "
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "deliver_times",
              label: "回调网关次数",
              width: "140"
            }
          }),
          _c("el-table-column", {
            attrs: { prop: "create_time", label: "创建时间", width: "180" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          row.create_time
                            ? _vm.$times.timestampToTime(row.create_time)
                            : "/"
                        ) +
                        " "
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "callback_time", label: "被回调时间", width: "180" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          row.callback_time
                            ? _vm.$times.timestampToTime(row.callback_time)
                            : "/"
                        ) +
                        " "
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "deliver_time",
              label: "最新分发时间",
              width: "180"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          row.deliver_time
                            ? _vm.$times.timestampToTime(row.deliver_time)
                            : "/"
                        ) +
                        " "
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "success_time",
              label: "成功处理时间",
              width: "180"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          row.success_time
                            ? _vm.$times.timestampToTime(row.success_time)
                            : "/"
                        ) +
                        " "
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "prepay_id",
              label: "支付平台订单凭证",
              width: "180",
              "show-overflow-tooltip": ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c(
                      "div",
                      {
                        staticClass: "text-ellipsis-1",
                        staticStyle: { width: "180px" },
                        on: {
                          click: function($event) {
                            return _vm.$utils.capy(row.prepay_id)
                          }
                        }
                      },
                      [_vm._v(" " + _vm._s(row.prepay_id || "/") + " ")]
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "prepare_time", label: "预下单时间", width: "180" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          row.prepare_time
                            ? _vm.$times.timestampToTime(row.prepare_time)
                            : "/"
                        ) +
                        " "
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "ip", label: "支付IP", width: "160" }
          }),
          _c("el-table-column", {
            attrs: { prop: "open_id", label: "小程序用户ID", width: "180" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [_vm._v(" " + _vm._s(row.open_id || "/") + " ")]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              label: "操作",
              width: "100",
              align: "center",
              fixed: "right"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    row.is_repaired != 1 && row.order_state != 7
                      ? _c("div", { staticClass: "x-c" }, [
                          _c(
                            "div",
                            {
                              staticClass: "controlsBtn",
                              on: {
                                click: function($event) {
                                  return _vm.hndleRepairOrder(row)
                                }
                              }
                            },
                            [_vm._v("补单")]
                          )
                        ])
                      : _vm._e()
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm.tableData.length
        ? _c("el-pagination", {
            attrs: {
              layout: "total, prev, pager, next",
              "current-page": _vm.paramsData.page,
              total: _vm.total,
              "page-size": _vm.paramsData.page_size
            },
            on: { "current-change": _vm.getList }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }